// extracted by mini-css-extract-plugin
export default {"background_wrapper":"BackgroundLayout_background_wrapper__XMMLo","wrapper":"BackgroundLayout_wrapper__oY0pX","paddingBottom":"BackgroundLayout_paddingBottom__qfyPI"};